import { IApplicationState } from '@spinwise/spinwise-core';
import { useSelector } from 'react-redux';

/**
 * Hide auth buttons from US users
 */
const useShowAuthButtons = () => {
  const geoCode = useSelector((state: IApplicationState) => state.globalReducer.geo.code2);
  
  return geoCode !== 'US';
};

export default useShowAuthButtons;
